// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CMEI","comment":"styles_comment__1Tg8j"};